import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

import { LensActiveIcon, LensIcon } from '@infl-ts/ui-advocate-icons';
import { ActiveLens } from '@infl-ts/util-lens';
import { Box, css, styled, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var lensStyles = function lensStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  height: ", ";\n  width: ", ";\n  color: ", ";\n\n  ", " {\n    height: ", ";\n    width: ", ";\n  }\n"])), theme.spacing(1), theme.spacing(4), theme.spacing(4), theme.palette.neutral.contrastText, theme.breakpoints.down('md'), theme.spacing(3), theme.spacing(3));
};

var InactiveLensIcon = styled(LensIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), lensStyles);
var ActiveLensIcon = styled(LensActiveIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  fill: ", ";\n"])), lensStyles, function (props) {
  return props.theme.palette.accent.main;
});

var LensLabel = function LensLabel(_ref2) {
  var lens = _ref2.lens,
      isMobile = _ref2.isMobile;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    },
    "data-element": "Box",
    "data-component": "LensLabel",
    "data-source-file": "lens-label.tsx",
    children: [ActiveLens.is(lens) ? /*#__PURE__*/_jsx(ActiveLensIcon, {}) : /*#__PURE__*/_jsx(InactiveLensIcon, {}), /*#__PURE__*/_jsx(Typography, {
      variant: isMobile ? 'body2' : undefined,
      sx: {
        whiteSpace: 'nowrap',
        color: function color(theme) {
          return theme.palette.neutral.contrastText;
        }
      },
      "data-element": "Typography",
      "data-component": "LensLabel",
      "data-source-file": "lens-label.tsx",
      children: "View Lens"
    })]
  });
};

export default LensLabel;